import { colorPrimary } from "@/constants/colors";
import { useTranslate } from "@/hooks";
import { IconButton } from "@/ui";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { Autocomplete, Box, Menu, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { IAbonentsTableSettings } from "./AbonentsTableSettings.props";
import { Hint } from "@/HOC";

const AbonentsTableSettings = ({ parentBlockWidth, hint = "", optionalColumnsList, selectedOptionalColumn, setSelectedOptionalColumn }: IAbonentsTableSettings) => {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null); // якорь для меню пользователя
	const translate = useTranslate(); // hook для перевода текста

	return parentBlockWidth < 150 ? (
		<>
			<IconButton
				icon={faGear}
				sx={{ marginLeft: "6px" }}
				size="medium"
				onClick={(e: any) => setAnchorEl(e.currentTarget)}
				title={translate("button_tableSettings")}
				iconColor={colorPrimary}
			/>
			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={() => setAnchorEl(null)}
				anchorOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
			>
				<Box sx={{ p: "16px", display: "flex", flexDirection: "column", gap: "16px" }}>
					<Typography sx={{ fontSize: 13 }}>{translate("title_abonentsTableSettings")}</Typography>
					<Hint hint={hint} position="right">
						<Autocomplete
							options={optionalColumnsList ?? []}
							value={selectedOptionalColumn ?? ""}
							freeSolo
							clearOnBlur={false}
							onChange={(_, newValue) => {
								if (typeof newValue === "string") {
									setSelectedOptionalColumn(newValue);
								}
							}}
							onInputChange={(_, newInputValue) => {
								setSelectedOptionalColumn(newInputValue);
							}}
							renderInput={(params) => (
								<TextField
									{...params}
									sx={{
										"& .MuiOutlinedInput-notchedOutline legend": {
											width: "125px", // убирает лишний запас справа
										},
									}}
									InputLabelProps={{
										sx: {
											"&.MuiInputLabel-shrink": {
												transform: "translate(14px, -8px) scale(0.8)",
											},
										},
									}}
									label={translate("input_optionalColumn")}
									size="small"
								/>
							)}
							ListboxProps={{
								sx: {
									"& .MuiAutocomplete-option": {
										fontSize: 13,
										padding: "6px 12px",
									},
								},
							}}
							sx={{
								color: "#918c8c",
								minWidth: "200px",
								maxWidth: "200px",

								"& .MuiInputBase-root": {
									pt: "6px !important",
									pb: "6px !important",
								},
								"& .MuiInputBase-input": {
									padding: "4px 0",
									fontSize: 13,
								},
							}}
						/>
					</Hint>
				</Box>
			</Menu>
		</>
	) : (
		<Hint hint={hint} offset={[0, -8]} position="left">
			<Autocomplete
				options={optionalColumnsList ?? []}
				value={selectedOptionalColumn ?? ""}
				freeSolo
				disablePortal
				clearOnBlur={false}
				onChange={(_, newValue) => {
					if (typeof newValue === "string") {
						setSelectedOptionalColumn(newValue);
					}
				}}
				onInputChange={(_, newInputValue) => {
					setSelectedOptionalColumn(newInputValue);
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						sx={{
							"& .MuiOutlinedInput-notchedOutline legend": {
								width: "125px", // убирает лишний запас справа
							},
						}}
						InputLabelProps={{
							sx: {
								"&.MuiInputLabel-shrink": {
									transform: "translate(14px, -8px) scale(0.8)",
								},
							},
						}}
						label={translate("input_optionalColumn")}
						size="small"
					/>
				)}
				ListboxProps={{
					sx: {
						"& .MuiAutocomplete-option": {
							fontSize: 13,
							padding: "6px 12px",
						},
					},
				}}
				sx={{
					color: "#918c8c",
					minWidth: "120px",
					maxWidth: "120px",

					"& .MuiInputBase-root": {
						pt: "6px !important",
						pb: "6px !important",
					},
					"& .MuiInputBase-input": {
						padding: "4px 0",
						fontSize: 13,
					},
				}}
			/>
		</Hint>
	);
};

export default AbonentsTableSettings;
